export class ArrayHelper
{
    public static union<T>(array1: T[], array2: T[], compareFunction: (a: T, b: T) => boolean): T[]
    {
        return [...array1, ...array2].reduce((acc: T[], current) => 
        {
            if (!acc.some(item => compareFunction(item, current))) acc.push(current);        
            return acc;
        }, []);
    }

    public static uniqueFilter(value, index, self) {
        return self.indexOf(value) === index;
    }
}